/* eslint-disable */
import debounce from "lodash.debounce";
import {
  CARD_NAME,
  FHS_SEGMENTS,
  REGEX_PATTERN_EMAIL,
  REGEX_PATTERN_URL,
  REGEX_PATTERN_WHITESPACE,
  SEGMENT_INFLUENCING_FACTOR,
  THUMBNAIL_TYPE,
} from "./global";
import lang from "../assets/i18n/en.json";
import exportimages from "../assets/images/exportImages";
import { useEffect, useRef } from "react";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import html2canvas from "html2canvas";
import { PDFstyles } from "../Components/Bank/report/widget/FinancialHealthScore/FinancialHealthScoreDetails/FinancialHealthScoreDetailsPDF";
import { loadImageAsBase64 } from "../Components/Bank/report/widget/FinancialHealthScore/FinancialHealthScoreDetails/PDFUtils";

const equalsIgnoreCase = (string1, string2) => {
  if (
    undefined === string1 ||
    null === string1 ||
    undefined === string2 ||
    null === string2
  ) {
    return false;
  }
  if (
    string1.toString().trim().toUpperCase() ===
    string2.toString().trim().toUpperCase()
  ) {
    return true;
  }
  return false;
};
export const clearAndLogout = debounce((name) => sessionTimeOut(), 1000);
const sessionTimeOut = () => {
  window.alert("Your session has expired. Please sign in again.");
  sessionStorage.clear();
  let currentURL = window.location.href.split("/");
  if (currentURL[3] === "admin") {
    window.location = "/admin-signin";
  } else {
    window.location = "/signin";
  }
};
export function addCommas(number) {
  if (number == null || isNaN(number)) {
    return "0"; // Return an empty string or handle undefined cases
  }

  const numberString = number.toFixed(2); // Ensure 2 decimal places
  const parts = numberString.split(".");

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Remove trailing zeros and decimal point if unnecessary
  return parts[1] === "00" ? parts[0] : parts.join(".");
}
const matchSpecialCharacters = (string) => {
  let pattern = /^[\w\s&.\-]*$/;

  if (string.match(pattern)) {
    return false;
  }

  return true;
};
const convertLocalDateToUTCDate = (date) => {
  let utcDateTime = "";

  utcDateTime = new Date(date).toISOString();

  return utcDateTime;
};
// export const validateEmail = (email) => {
//   return !email.match(
//     /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//   );
// };
export const getTimestamp = () => {
  return Date.now();
};
export function convertToTitleCase(input) {
  // Split the input string into words
  const words = input.split(" ");

  // Capitalize the first letter of each word
  const titleCaseWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1)?.toLowerCase();
  });

  // Join the words back together
  const titleCaseString = titleCaseWords.join(" ");

  return titleCaseString;
}
export const validateEmail = (emailId, errors, setError) => {
  let email = emailId.trim();
  /** VALIDATING EMAIL  */
  let checkWorkEmail = email.toLowerCase();
  const regex = REGEX_PATTERN_EMAIL();
  const whiteSpace = REGEX_PATTERN_WHITESPACE();

  // Check if user has entered at least one character after '@'
  const isCompleteEmail =
    email?.includes("@") || email?.split("@")[1]?.includes(".");
  // let workMail = !(
  //   checkWorkEmail.includes("gmail") ||
  //   checkWorkEmail.includes("yahoo") ||
  //   checkWorkEmail.includes("outlook") ||
  //   checkWorkEmail.includes("hotmail") ||
  //   checkWorkEmail.includes("aol")
  // );
  // Perform validation only when it's a more complete email
  if (isCompleteEmail) {
    if (regex.test(email) && email.match(whiteSpace) && email.length < 500) {
      setError((errors) => ({
        ...errors,
        email: false,
        emailError: "",
      }));
    } else if (email.length > 500) {
      setError((errors) => ({
        ...errors,
        email: true,
        emailError: lang?.PAGE?.AUTH?.SIGNUP?.EMAIL?.MAX_LENGTH,
      }));
    } else {
      setError((errors) => ({
        ...errors,
        email: true,
        emailError: "Must enter a valid work email address.",
      }));
    }
  } else {
    // Clear the error if the user hasn't finished entering the email
    setError((errors) => ({
      ...errors,
      email: true,
      emailError: "",
    }));
  }
};

export function stringToHex(str) {
  let hex = "";
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i).toString(16);
    hex += ("00" + charCode).slice(-2);
  }
  return hex;
}
export function hexToString(hex) {
  let str = "";
  for (let i = 0; i < hex.length; i += 2) {
    let charCode = parseInt(hex.substr(i, 2), 16);
    str += String.fromCharCode(charCode);
  }
  return str;
}

export const validateDateTime = (value, errors, setError) => {
  /** VALIDATING Date and time  */
  const selectedDateTime = new Date(value).getTime();
  const currentDateTime = new Date().getTime();
  if (value === "") {
    setError((errors) => ({
      ...errors,
      scheduledFor: true,
      scheduledForError: "Scheduled date cannot be empty!",
    }));
  } else if (selectedDateTime < currentDateTime) {
    setError((errors) => ({
      ...errors,
      scheduledFor: true,
      scheduledForError:
        "Please select a time that is ahead of the current time.",
    }));
  } else {
    setError((errors) => ({
      ...errors,
      scheduledFor: false,
      scheduledForError: "",
    }));
  }
};

export const validateEmailTemplate = (data) => {
  if (!data?.design?.body) {
    return true;
  }
  const {
    design: { body },
  } = data;
  const { rows } = body;
  let isEmpty = true;
  label: for (let i = 0; i < rows.length; i++) {
    const { columns } = rows[i];
    for (let j = 0; j < columns.length; j++) {
      const { contents } = columns[j];
      if (contents.length) {
        isEmpty = false;
        break label;
      }
    }
  }
  return isEmpty;
};

export function AmountsInThousand(number) {
  if (number != 0) {
    // number = number / 1000;
    const numberString = number.toFixed(2); // Ensure 2 decimal places
    const parts = numberString.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts[0];
  } else {
    return number;
  }
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";path=/" +
    `${process.env.REACT_APP_COOKIE_SAME_SITE ?? ""}` +
    `${process.env.REACT_APP_COOKIE_SECURE ?? ""}` +
    `${process.env.REACT_APP_COOKIE_HTTP_ONLY ?? ""}`;
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name +
      "=;" +
      "expires=Thu, 01-Jan-1970 00:00:01 GMT;" +
      "path=" +
      "/;" +
      "domain=" +
      window.location.host +
      ";" +
      "secure=;";
  }
}

export const domainName = (url) =>
  url.replace(/^https?:\/\//, "").replace(/^www\./, "");

export const fetchCurrentCachedState = (cachedQueries) => {
  const result = {};

  if (!cachedQueries) return result;

  Object.values(cachedQueries).forEach((item) => {
    if (item?.status === "fulfilled") {
      // const key = `${item.endpointName}:${JSON.stringify(item.originalArgs ?? {})}`;
      const key = `${item.endpointName}`;
      result[key] = item?.data?.data;
    }
  });

  return result;
};

export const parseFirstImagefromHtml = (html) => {
  let ele = document.createElement("div");
  ele.innerHTML = html;
  const imagesArray = [];
  const imagesArrayNodeList = ele.querySelectorAll("img, div.u-row-container");
  imagesArrayNodeList.forEach((item) => {
    if (item?.src) {
      imagesArray.push({ src: item?.src, height: item?.height });
    } else {
      item?.style?.backgroundImage &&
        imagesArray.push({
          src: item?.style?.backgroundImage?.slice(4, -1).replace(/"/g, ""),
          height: item?.height ? item?.height : "auto",
        });
    }
  });
  imagesArray.sort((a, b) => b.height - a.height);
  const prompts = ["data:", "unlayer", "oaidalleapiprodscus"];
  const image = imagesArray?.find((imgURL) =>
    prompts?.some((promptName) => imgURL?.src?.indexOf(promptName) !== -1),
  );
  const imageURL = image
    ? image?.src?.match(/https/g)?.length > 1
      ? image?.src?.slice(image?.lastIndexOf("https"))
      : image?.src
    : null;
  const decodedURL =
    imageURL && imageURL?.match(/%22/g)?.length > 0
      ? imageURL?.slice(0, -4)
      : imageURL;
  return decodedURL;
};

export const checkImage = (template) => {
  const base_url = process.env.REACT_APP_CAMPAIGN_THUMBNAIL_URL;
  const url = `${base_url}${template?.templateThumbnail[0]?.url}`;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(true); // Image is valid
    };
    img.onerror = () => {
      resolve(false); // Image is invalid
    };
    img.src = url;
  });
};

export const checkLegendIcon = (icon) => {
  return [
    "icon_default",
    "icon_auto_loan",
    "icon_credit_card",
    "icon_student_loan",
    "icon_business_loan",
    "icon_commercial_loan",
    "icon_mortgage",
    "icon_consumer_loan",
    "icon_personal_loan",
    "icon_primary_consumers",
    "icon_secondary_consumers",
    "icon_general_merchandise",
    "icon_restaurant",
    "icon_gaming",
    "icon_entertainment",
    "icon_personal_care",
    "icon_service_fee",
    "icon_payment",
    "icon_groceries",
    "icon_electronics",
    "icon_other_income",
    "icon_clothing",
    "icon_digital_wallet",
    "icon_travel",
    "icon_pension_and_insurance",
    "icon_mobile",
    "icon_bill_payment",
    "icon_withdrawal",
    "icon_fast_food",
    "icon_online_service",
    "icon_healthcare",
    "icon_beverage",
    "icon_late_payment",
    "icon_transfer",
    "icon_gifts",
    "icon_gas_and_fuel",
    "icon_food_and_drink",
    "icon_primary_consumer_with_dda",
    "icon_primary_consumer_without_dda",
    "icon_secondary_consumer_with_dda",
    "icon_secondary_consumer_without_dda",
    "icon_transportation",
    "icon_medical",
    "icon_home_improvement",
    "icon_general_services",
    "icon_rent_and_utilities",
    "icon_account_transfer",
    "icon_investment_and_retirement_funds",
    "icon_savings",
    "icon_529_education_accounts",
    "icon_ira",
    "icon_certificates_of_deposit",
    "icon_checking",
    "icon_health_savings_account",
    "icon_person_to_person",
    "icon_investment",
  ].includes(icon);
};

export const getThumbnailImage = (isValid, item) => {
  const base_url = process.env.REACT_APP_CAMPAIGN_THUMBNAIL_URL;
  if (isValid) {
    return {
      image: `${base_url}${item?.templateThumbnail[0]?.url}`,
      alt: item?.name,
      content: `${item?.templateThumbnail[0]?.content}`,
    };
  } else {
    return {
      image: exportimages?.no_image,
      defaultType: true,
      alt: item?.name,
    };
  }
};

export const formatToDollar = (value) => {
  let dollarUSLocale = Intl.NumberFormat("en-US");
  return dollarUSLocale.format(Math.round(Number(value)));
};

export const getDifferenceMessage = (trend, trend_dollar) => {
  let message = "";
  if (trend > 0) {
    if (trend_dollar) {
      message += `Increase from last quarter by $${trend_dollar}.`;
    } else {
      message += `Increase from last quarter.`;
    }
  } else if (trend < 0) {
    if (trend_dollar) {
      message += `Decrease from last quarter by $${trend_dollar}.`;
    } else {
      message += `Decrease from last quarter.`;
    }
  } else if (trend == 0) {
    if (trend_dollar) {
      message += `Same as last quarter as $${trend_dollar}.`;
    } else {
      message += `Same as last quarter.`;
    }
  }
  return message;
};

// export const getDifferenceClass = (trend, is_reverse) => {
//   let classString = "";
//   if (is_reverse === "true") {
//     if (trend > 0) {
//       classString += "red-color upward-arrow-red";
//     } else if (trend < 0) {
//       classString += "green-color downward-arrow-green";
//     } else {
//       classString += "orange-color";
//     }
//   } else if (is_reverse === "false") {
//     if (trend > 0) {
//       classString += "green-color upward-arrow-green";
//     } else if (trend < 0) {
//       classString += "red-color downward-arrow-red";
//     } else {
//       classString += "orange-color";
//     }
//   }
//   return classString;
// };

//Old code
export const getDifferenceClass = (
  forecastedValue,
  currentValue,
  is_reverse,
) => {
  let classString = "";
  if (is_reverse === "true") {
    if (forecastedValue > currentValue) {
      classString += "red-color upward-arrow-red";
    } else if (forecastedValue < currentValue) {
      classString += "green-color downward-arrow-green";
    } else {
      classString += "orange-color";
    }
  } else if (is_reverse === "false") {
    if (forecastedValue > currentValue) {
      classString += "green-color upward-arrow-green";
    } else if (forecastedValue < currentValue) {
      classString += "red-color downward-arrow-red";
    } else {
      classString += "orange-color";
    }
  }
  return classString;
};

//new code - 27-02-2025 for fhs page only
export const getDifferenceClassForFHS = (
  forecastedValue,
  currentValue,
  is_reverse,
) => {
  if (forecastedValue === currentValue) return "orange-color";

  const isReverse = is_reverse === "true";
  const isIncrease = forecastedValue > currentValue;

  const direction = isIncrease ? "upward" : "downward";
  const color = isReverse
    ? isIncrease
      ? "red"
      : "green"
    : isIncrease
      ? "green"
      : "red";

  const alignment = "align-middle";

  return `bg-transparent ${color}-${direction}-arrow ${alignment} arrow-dimension`;
};

export const getArrowIndicatorClass = (triggerFrom, showAPValue, segment) => {
  if (
    Number(segment?.current) === Number(segment?.forecasted) &&
    Number(segment?.current) === Number(segment?.final_AP_value)
  ) {
    return "";
  }
  const classStringForecasted = getDifferenceClassForFHS(
    segment?.forecasted,
    segment?.current,
    segment?.is_reverse,
  );
  const classStringAPValue = getDifferenceClassForFHS(
    segment?.final_AP_value,
    segment?.current,
    segment?.is_reverse,
  );
  const isForecastTrigger = triggerFrom === "isForcasted";

  if (Number(segment?.forecasted) !== Number(segment?.final_AP_value)) {
    if (!showAPValue) {
      return isForecastTrigger ? classStringForecasted : classStringAPValue;
    }
    const hasGreen =
      classStringForecasted.includes("green") ||
      classStringAPValue.includes("green");
    const hasRed =
      classStringForecasted.includes("red") ||
      classStringAPValue.includes("red");

    if (hasGreen) {
      return isForecastTrigger
        ? classStringForecasted.replace("green", "orange")
        : classStringAPValue;
    }

    if (hasRed) {
      return isForecastTrigger
        ? classStringForecasted
        : classStringAPValue.replace("red", "orange");
    }
  }

  return isForecastTrigger ? classStringForecasted : classStringAPValue;
};

export const getArrowIndicatorBase64Image = (
  triggerFrom,
  showAPValue,
  segment,
) => {
  const indicatorClassString = getArrowIndicatorClass(
    triggerFrom,
    showAPValue,
    segment,
  );

  return indicatorClassString?.split(" ")[1]?.replace(/-/g, "_");
};

export const getDifferencePropsForFHS = (
  forecastedValue,
  currentValue,
  is_reverse,
) => {
  if (is_reverse === "true") {
    if (forecastedValue > currentValue) {
      return { style: PDFstyles.redUp, symbol: "\u25B2" }; // ▲
    } else if (forecastedValue < currentValue) {
      return { style: PDFstyles.greenDown, symbol: "\u25BC" }; // ▼
    } else {
      return { style: PDFstyles.orangeNeutral, symbol: "" }; // no change
    }
  } else if (is_reverse === "false") {
    if (forecastedValue > currentValue) {
      return { style: PDFstyles.greenUp, symbol: "\u25B2" }; // ▲
    } else if (forecastedValue < currentValue) {
      return { style: PDFstyles.redDown, symbol: "\u25BC" }; // ▼
    } else {
      return { style: PDFstyles.orangeNeutral, symbol: "" }; // no change
    }
  }

  return { style: PDFstyles.orangeNeutral, symbol: "" }; // default fallback
};

export const convertMappingResponse = (payload) => {
  const mappedResponse = {};
  for (const [key, value] of Object.entries(payload)) {
    if (typeof value === "object" && !(value instanceof Array)) {
      const result = Object.entries(value).map(([key, value]) => {
        return { key, ...value };
      });
      mappedResponse[key] = result;
    } else {
      mappedResponse[key] = value;
    }
  }
  return mappedResponse;
};

export function getRangeCategory(value) {
  if (value >= 1 && value <= 40) {
    return "requires action";
  } else if (value >= 41 && value <= 65) {
    return "needs attention";
  } else if (value >= 66 && value <= 85) {
    return "good";
  } else if (value >= 86 && value <= 100) {
    return "optimal";
  }
}

export const minDateInCalander = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const day = today.getDate();

  const minDate = new Date(year, month, day);

  minDate.setHours(0, 0, 0, 0);
  return minDate;
};

export function calculatePercentage(data) {
  const symbol =
    [...FHS_SEGMENTS, ...SEGMENT_INFLUENCING_FACTOR].find(
      (i) => i.key === data.key,
    )?.symbol ?? null;
  const percentCalculate =
    data?.current !== 0
      ? ((data?.forecasted - data?.current) / Math.abs(data?.current)) * 100
      : 0;
  return Number(percentCalculate.toFixed(2));
}

//new code - 27-02-2025
export function calculatePercentageforAP_used(data) {
  const symbol =
    [...FHS_SEGMENTS, ...SEGMENT_INFLUENCING_FACTOR].find(
      (i) => i.key === data.key,
    )?.symbol ?? null;
  const percentCalculate =
    data?.current !== 0
      ? ((data?.ap_used - data?.current) / Math.abs(data?.current)) * 100
      : 0;
  return Number(percentCalculate.toFixed(2));
}

// export function calculateTrendPercentage(groupedResult) {
//   return {
//     // all_segments: groupedResult?.all_segments?.map((data) => ({
//     profitability: groupedResult?.profitability?.map((data) => ({
//       ...data,
//       key: data.key,
//       forecasted_trend: calculatePercentage(data),
//       autopilot_trend: calculatePercentageforAP_used(data), //new code - 27-02-2025
//     })),
//     // segment_influencing: groupedResult?.segment_influencing?.map((data) => ({
//     growth_metrics: groupedResult?.growth_metrics?.map((data) => ({
//       ...data,
//       key: data.key,
//       forcasted_trend: calculatePercentage(data),
//       autopilot_trend: calculatePercentageforAP_used(data), //new code - 27-02-2025
//     })),
//   };
// }

export function calculateTrendPercentage(segmentData) {
  return segmentData?.map((data) => ({
    ...data,
    key: data.key,
    forecasted_trend: calculatePercentage(data),
    autopilot_trend: calculatePercentageforAP_used(data), // new code - 27-02-2025
  }));
}

export function checkFileUploadSize(templateObj) {
  const payload = JSON.stringify(templateObj);
  if (payload.length > 2097152) {
    // 2MB limit
    let fileUploadError =
      "The file is uploading; please wait until the process is complete.";
    return fileUploadError;
  }
}

export const getBase64FromSource = async (source) => {
  // Case 1: If source is a selector (starts with "." or "#")
  if (
    typeof source === "string" &&
    (source.startsWith(".") || source.startsWith("#"))
  ) {
    const chartContainer = document.querySelector(source);

    if (!chartContainer) {
      console.error(`Chart container not found for selector: ${source}`);
      return null;
    }

    const canvas = await html2canvas(chartContainer, {
      scale: 2,
      useCORS: true,
      backgroundColor: "transparent",
    });

    return canvas.toDataURL("image/png");
  }

  // Case 2: Assume it's an image URL
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
    img.onerror = (err) => {
      console.error("Image load error:", err);
      reject(err);
    };
    img.src = source;
  });
};
export function centsToDollars(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

export function transformBankName(name) {
  const containsBondAI = /BOND\.AI/i.test(name);

  function toTitleCase(str) {
    return str
      ?.split(" ")
      ?.map((word) => {
        // Match: optional leading punctuation, first letter, middle letters, optional trailing punctuation
        const match = word.match(
          /^([^a-zA-Z]*)([a-zA-Z])([a-zA-Z]*)([^a-zA-Z]*)$/,
        );
        if (match) {
          const [, leadPunct, firstChar, rest, trailPunct] = match;
          return (
            leadPunct +
            firstChar.toUpperCase() +
            rest.toLowerCase() +
            trailPunct
          );
        }
        return word.toLowerCase(); // fallback for numbers/symbols
      })
      .join(" ");
  }

  if (containsBondAI) {
    const cleaned = name.replace(/BOND\.AI/i, "").trim();
    return `BOND.AI ${toTitleCase(cleaned)}`;
  } else {
    return toTitleCase(name);
  }
}

export function getSelectedCardName() {
  const pathSegments = window.location.pathname.split("/");
  const urlParams = pathSegments[7];
  let name = "";
  let key = "";
  if (urlParams === "CrossSellOpp") {
    name = "Product Opportunities";
    key = CARD_NAME.OPPORTUNITIE;
  } else if (urlParams === "Secondary_Consumer") {
    // name = "Boost Deposits";
    name = "Deposit Opportunities";
    key = CARD_NAME.BOOST_DEPOSIT;
  } else if (urlParams === "Ghost_Consumer") {
    name = "Ghost Consumers";
    key = CARD_NAME.GHOST_CONSUMER;
  } else if (urlParams === "Top_Merchant") {
    name = "Top Merchants";
    key = CARD_NAME.TOP_MERCHANT;
  }
  return { name, key };
}
export function calculateAPValue(segmentData, metricsObject) {
  // return segmentData?.map((data) => {
  //   const delta_value = (metricsObject?.[data?.key] ?? 0) / 100;
  //   const AP_value_segment = (data.forecasted * delta_value).toFixed(2);
  //   const final_AP_value = parseFloat(AP_value_segment) + data.forecasted;
  //   const forecasted_trend =
  //     data?.current !== 0
  //       ? ((data?.forecasted - data?.current) / Math.abs(data?.current)) * 100
  //       : 0;
  //   const autopilot_trend =
  //     data?.current !== 0
  //       ? ((final_AP_value - data?.current) / Math.abs(data?.current)) * 100
  //       : 0;
  //   return {
  //     ...data,
  //     forecasted_trend: forecasted_trend.toFixed(2),
  //     autopilot_trend: autopilot_trend.toFixed(2),
  //     final_AP_value,
  //   };
  // });

  return segmentData?.map((data) => {
    let final_AP_value = data?.forecasted; // default, in case we skip calc

    if (
      data?.key === "net_interest_income" ||
      data?.key === "non_interest_expense" ||
      data?.key === "total_assets" ||
      data?.key === "total_loans" ||
      data?.key === "total_deposits"
    ) {
      const delta_value = (metricsObject?.[data?.key] ?? 0) / 100;
      const AP_value_segment = (data.forecasted * delta_value).toFixed(2);
      final_AP_value = data?.forecasted
        ? parseFloat(AP_value_segment) + data?.forecasted
        : 0;
    } else {
      const delta_value = metricsObject?.[data?.key] ?? 0;
      final_AP_value = data?.forecasted
        ? (data?.forecasted + delta_value).toFixed(2)
        : 0;
    }

    const forecasted_trend =
      data?.current !== 0
        ? ((data?.forecasted - data?.current) / Math.abs(data?.current)) * 100
        : 0;

    const autopilot_trend =
      data?.current !== 0
        ? ((final_AP_value - data?.current) / Math.abs(data?.current)) * 100
        : 0;

    const final_forecasted = data?.current !== 0 ? data?.forecasted : 0;

    final_AP_value = data?.current !== 0 ? final_AP_value : 0;

    return {
      ...data,
      forecasted_trend: forecasted_trend.toFixed(2),
      autopilot_trend: autopilot_trend.toFixed(2),
      forecasted: final_forecasted,
      final_AP_value,
    };
  });
}

export const getOrdinalSuffix = (value) => {
  if (value === null || value === undefined) return "";

  const num = Number(value);
  if (Number.isNaN(num)) return "";

  const lastTwoDigits = num % 100;

  // Special case: 11, 12, 13 → "th"
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return "th";
  }

  switch (num % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
